export default "__VITE_ASSET__DGVhPvTW__"